export default {
    verifying_login: "Verifying login...",
    login_succeeded: "Login succeeded",
    validation_failed: "Validation failed",
    parameter_acquisition_failed: "Parameter acquisition failed",
    loading: "loading...",
};
